import { createReducer } from '@reduxjs/toolkit'
import { merge, forEach } from 'lodash-es'
import ActionTypes from '@constants/action_types.js'

const initialState = {
  entities: {},
}

export const accountMembership = createReducer(initialState, builder => {
  builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
})

function receiveEntities(state, action) {
  const { payload } = action

  if (payload.hasOwnProperty('account_membership')) {
    throw new Error('Single account membership payload processing TBI')
    /*
    const { account_membership: accountMembership } = payload
    const idString = accountMembership.id.toString()
    state.entities[idString] = merge(state.entities[idString] || {}, accountMembership)
    */
  }

  if (payload.hasOwnProperty('account_memberships')) {
    const { account_memberships: accountMemberships } = payload
    forEach(accountMemberships, accountMembership => {
      const idString = accountMembership.id.toString()
      state.entities[idString] = merge(state.entities[idString] || {}, accountMembership)
    })
  }
  return state
}

export default accountMembership
